import axios from "axios";
import { useMemo, useState } from "react";

const getNFTWallets = async () => {
    try {
        const { data } = await axios.get(
            process.env.REACT_APP_API_URL + "/marketOverview/totalNFTWallets"
        )
        return data;
    }
    catch (error) {
        return error;
    }
}

export function useNFTWallets() {
    const [api, setAPIData] = useState<any>({
        loading: true,
        error: false,
        data: undefined
    });



    useMemo(async () => {
        const data = await getNFTWallets();
        setAPIData({
            loading: false,
            error: false,
            data: data
        })
    }, [])
    return api;
}
